<template>
    <div>
        <div class="relative">
            <input
            type="text"
            v-model="addressSearchInput"
            @input="searchAddress"
            class="w-full px-0 py-1 text-lg font-bold text-black border-0 border-b focus:border-transparent focus:border-b-black focus:ring-0"
            :placeholder="placeholder"
            test-id="address-input"
            >
            <!-- List results -->
            <div class="absolute w-full overflow-y-auto text-black bg-white border shadow rounded-b-xl max-h-40">
                <div @click="selectAddress(result)" v-for="(result, resultIndex) in results" :key="'address-result-' + resultIndex" :class="resultIndex < results.length -1 ? 'border-b' : ''" class="p-4 text-sm duration-100 cursor-pointer hover:bg-gray-50" :test-id="'address-search-result-' + resultIndex">
                    <i class="mr-2 fas fa-location-dot"></i> {{result.formatted_address}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MapService from '@/services/map.service'

export default {
    props: {
        placeholder: {},
        country: {}
    },

    watch: {
        country: function(value) {
            this.addressSearchInput = null
            this.results = []
        }
    },

    data() {
        return {
            addressSearchInput: "",
            results: []
        }
    },

    methods: {
        searchAddress() {
            if (this.addressSearchInput) {
                clearTimeout(this.timer)
                this.timer = setTimeout(async () => {
                    let responseAddresses = await MapService.search(this.addressSearchInput, this.country)
                    this.results = responseAddresses
                    this.results = responseAddresses.filter((address) => address.types.includes('premise') || address.types.includes('street_address'))
                }, 200)
            } else {
                this.results = []
            }
        },

        selectAddress(result) {
            this.addressSearchInput = result.formatted_address
            this.results = []
            console.log(JSON.stringify(result));
            this.$emit('get', result)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SavAddressInput_old.vue